import React, { ReactElement, useEffect } from 'react';
import { Error, NotFound } from '@shootsta/common-react';
import Loading from './Loading';
import PageContent from './PageContent';
import { useShareablePageContext } from '../contexts/ShareablePageContext';
import { usePublicAssetContext } from '../contexts/PublicAssetContext';
import { getAnalytics, setAnalytics } from '../../../utils';
import AnalyticsTypes from '../../../constants/AnalyticsTypes';
import { ICreateAnalyticsEntryQuery } from '../interfaces';

import '../styles/_shareable-page.scss';

interface ShareablePageProps {
  createAnalyticsEntry: ICreateAnalyticsEntryQuery;
}

export default function ShareablePage({
  createAnalyticsEntry
}: ShareablePageProps): ReactElement {
  const {
    shareablePage,
    error: shareablePageError,
    loading: shareablePageLoading
  } = useShareablePageContext();
  const {
    loading: publicAssetLoading,
    fetchPublicAsset
  } = usePublicAssetContext();

  useEffect(() => {
    if (!shareablePage) { return void 0; }
    fetchPublicAsset(shareablePage.assetId);
  }, [shareablePage, fetchPublicAsset]);

  useEffect(() => {
    const isPageViewAnalyticsSent = getAnalytics(AnalyticsTypes.PAGE_VIEW);
    if (!shareablePage || isPageViewAnalyticsSent) {
      return void 0;
    }
    (async () => {
      const { error, data } = await createAnalyticsEntry(AnalyticsTypes.PAGE_VIEW);
      if (error || !data?.createAnalyticsEntry) {
        return void 0;
      }
      setAnalytics(AnalyticsTypes.PAGE_VIEW);
    })();
  }, [createAnalyticsEntry, shareablePage]);

  if (shareablePageError) {
    return <Error />;
  }
  if (shareablePage === null) {
    return <NotFound />;
  }
  if (shareablePageLoading || publicAssetLoading) {
    return (
      <main className="main-loader">
        <Loading />
      </main>
    );
  }

  return <PageContent />;
}
